var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VBtn',{staticClass:"focus:outline-none",attrs:{"icon":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('VIcon',{attrs:{"medium":""}},[_vm._v("mdi-reload")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }